<div class="group/wrapper relative w-full">
    <div
        class="relative flex h-[51px] w-full cursor-pointer items-center justify-between gap-16 overflow-visible border-2 transition-all hover:border-blue hover:text-blue"
        [ngClass]="{
            'border-grey-400 bg-white text-black': theme() === 'light' || theme() === 'dark',
            'border-white bg-accent text-white': theme() === 'medium',
            'border-red': error() && !focussed(),
            '!border-grey-300': disabled(),
        }"
        [attr.title]="value() ?? ''"
        (click)="clicked.emit()"
    >
        @if (label()) {
            <div
                class="pointer-events-none absolute left-4 top-1/2 flex w-max -translate-y-1/2 items-center justify-center px-12 transition-transform"
                [ngClass]="{
                    'bg-white text-black': theme() === 'light' || theme() === 'dark',
                    'bg-accent text-white': theme() === 'medium',
                    'leading-0 h-[12px] -translate-x-[4px] -translate-y-[30px] py-2 text-12': focussed() || value(),
                    '!text-red': error() && !focussed(),
                    '!text-grey-400': disabled(),
                }"
            >
                {{ label() }}
            </div>
        }

        <ng-content>
            @if (valueOrPlaceholder(); as text) {
                <span
                    class="flex w-full select-none items-center justify-between overflow-hidden text-ellipsis text-nowrap py-12 pl-16 text-16 leading-27 text-transparent"
                    [ngClass]="{
                        '!select-auto !text-grey-400': disabled(),
                        '!select-auto !text-red': error() && !focussed(),
                        '!select-auto !text-black':
                            (focussed() || value() || !label()) && (theme() === 'light' || theme() === 'dark'),
                        '!select-auto !text-white': (focussed() || value() || !label()) && theme() === 'medium',
                    }"
                >
                    {{ text }}
                </span>
            }
        </ng-content>
        <div class="ml-auto py-12 pr-16 empty:hidden">
            <ng-content select="[trailing]" />
        </div>
    </div>
    @if (error() && errorMsg()) {
        <div class="h-16">
            <p class="leading-16 relative left-0 text-12 text-red">
                {{ errorMsg() }}
            </p>
        </div>
    }
</div>
